// Could use this to batch out the batch create requests (25 per)
const asyncForEach = async <T>(array: T[][], callback: (items: T[]) => Promise<boolean>): Promise<boolean[]> => {
	let promises: Promise<boolean>[] = [];
	for (let index = 0; index < array.length; index++) {
		const newStuff = callback(array[index]);
		promises = promises.concat(newStuff);
	}
	const resolved = await Promise.all(promises);
	// need to flatten
	let final: boolean[] = [];
	for (let i = 0; i < resolved.length; i++) {
		const element = resolved[i];
		final = final.concat(element);
	}

	return final;
};

const asyncForEachBatch = async <T>(array: T[][], callback: (items: T[]) => Promise<boolean>) => {
	return await asyncForEach(array, async (element: T[]) => {
		return await callback(element);
	});
};
export default asyncForEachBatch;
